import AModal from '@/components/A/AModal/AModal'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import styles from './AigcPromotionModal.module.less'
import { Trans, useTranslation } from 'react-i18next'
import { commonUtils } from '@/helpers/commonUtils'

interface Props {
  onAfterClose?: () => void
  onRegister?: () => void
}

function AigcPromotionModal(props: Props) {
  const { t } = useTranslation()
  const modal = useModal()

  const handleGoSignUp = () => {
    modal.hide()
    props.onRegister?.()
  }

  return (
    <AModal
      testId='aigc-promotion-modal'
      className={styles.aigcPromotionModal}
      width={570}
      open={modal.visible}
      onCancel={() => modal.hide()}
      footer={null}
      afterClose={() => {
        props.onAfterClose?.()
        modal.remove()
      }}
    >
      <div className={styles.aigcPromotionModalContent}>
        <div className={styles.visualBox}>
          <img
            className={styles.visualBg}
            src={commonUtils.getImagePath('homePage/aigc-promotion.png')}
            alt=''
          />
        </div>
        <div className={styles.titleRow}>
          <img
            className={styles.titleIcon}
            src={commonUtils.getImagePath('homePage/aigc-promotion-icon-1.png')}
            alt=''
          />
          <p className={styles.title}>{t('modals.aigcPromotionModal.title')}</p>
        </div>
        <p className={styles.subTitle}>
          <Trans
            i18nKey='modals.aigcPromotionModal.subTitle'
            components={{ tmp: <span className={styles.highlightFive} /> }}
          />
        </p>
        <div className={styles.descBox}>
          <p className={styles.desc}>{t('modals.aigcPromotionModal.desc1')}</p>
          <p className={styles.desc}>{t('modals.aigcPromotionModal.desc2')}</p>
        </div>
        <button className={styles.actionBtn} data-testid='aigc-promotion-register-btn' onClick={handleGoSignUp}>
          <span className={styles.actionIcon}>🚀</span>
          {t('modals.aigcPromotionModal.registerBtn')}
        </button>
        <p className={styles.tips}>{t('modals.aigcPromotionModal.tip')}</p>
      </div>
    </AModal>
  )
}

export default NiceModal.create(AigcPromotionModal)
